import {
  QuestionBase,
  QuestionControlOptions
} from '../question-types/question-base';
import { isNil } from 'lodash';

export interface DropdownOption {
  key: string;
  value: string;
}

export interface DropdownControlOptions extends QuestionControlOptions<string> {
  options?: DropdownOption[];
  placeholder?: string;
  onChange?: Function;
}

export class DropdownQuestion extends QuestionBase<string>
  implements DropdownControlOptions {
  controlType = 'dropdown';
  onChange?: Function;
  options: DropdownOption[] = [];
  placeholder?: string;

  // FIXME filter builder needs to be updated to use
  // a similar validation strategy as the dynamic forms
  // this shims compatibility until then
  isValid = true;

  constructor(options: DropdownControlOptions) {
    super(options);
    this.onChange = options.onChange || (_ => {});
    this.placeholder = options.placeholder || '';
    this.options = options.options || [];
    if (isNil(this.value) && this.options && this.options[0]) {
      this.value = this.options[0].key;
    }
  }

  onValueChange(value) {
    this.onChange(value);
  }
}
